import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 16px 8px 16px;
  flex: 1;
`;
